import type { Faq } from '../data/faq';
import { useI18n } from '../i18n/useI18n';

export function FaqItem({ item }: { item: Faq }) {
  const { t } = useI18n();

  return (
    <details className="faq-item">
      <summary>{t(item.questionKey)}</summary>
      <p>{t(item.answerKey)}</p>
    </details>
  );
}
